export default __webpack_public_path__ + "static/media/an2.106653fe.jpg";